module.exports = __webpack_public_path__ + "img/function01.b899c029.png";